import { SolitaireDealer } from './solitaire-dealer';
import { SolitaireListener } from '../../game/solitaire-listener';
import { CardId } from '../card/card-id';
import { Secret } from 'game-logic';

export class RemoteDealer implements SolitaireDealer {
  private readonly solitaireListener: SolitaireListener;
  private cachedDisclosedSecrets: Secret[] = [];

  constructor(solitaireListener: SolitaireListener) {
    this.solitaireListener = solitaireListener;
  }

  public async discloseCards(
    indexes: number[],
    gameHash: string,
    disclosedSecrets: number,
    existingDeal: boolean,
  ): Promise<string[]> {
    // Try and match indexes with cached disclosed secrets first
    const disclosedCards = this.matchDisclosedCards(indexes, this.cachedDisclosedSecrets);
    if (disclosedCards.length === indexes.length) {
      return disclosedCards;
    }
    // Get secrets from the cloud
    return await this.discloseSecrets(indexes, gameHash, disclosedSecrets, existingDeal);
  }

  private async discloseSecrets(
    indexes: number[],
    gameHash: string,
    disclosedSecrets: number,
    existingDeal: boolean,
  ): Promise<string[]> {
    const response = await this.solitaireListener.discloseSecrets(
      indexes,
      gameHash,
      disclosedSecrets,
      existingDeal,
    );
    if (response === undefined) {
      return [];
    }
    this.cacheSecrets(response);

    return this.matchDisclosedCards(indexes, response);
  }

  private matchDisclosedCards(indexes: number[], disclosedSecrets: Secret[]) {
    const disclosedCards: string[] = [];
    indexes.forEach((index) => {
      for (const secret of disclosedSecrets) {
        if (secret.index === index) {
          const cardId = new CardId(secret.value);
          disclosedCards.push(cardId.id);
          break;
        }
      }
    });
    return disclosedCards;
  }

  private cacheSecrets(secrets: Secret[]) {
    secrets.forEach((secret) => {
      if (!this.cachedDisclosedSecrets.some((existing) => existing.index === secret.index)) {
        this.cachedDisclosedSecrets.push(secret);
      }
    });
  }
}
